import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

export const DateTimeFormat = (utcDate) => {
    if (!utcDate) return '';
    return dayjs.utc(utcDate).tz(dayjs.tz.guess()).format('DD/MM/YYYY HH:mm');
};

export const DateTimeAgoFormat = (utcDate) => {
    if (!utcDate) return '';

    const now = dayjs();
    const date = dayjs.utc(utcDate).tz(dayjs.tz.guess());

    const diffMinutes = now.diff(date, 'minute');

    if (diffMinutes < 1) {
        return 'Just now';
    }

    if (diffMinutes < 60) {
        return `${diffMinutes} minute${diffMinutes > 1 ? 's' : ''} ago`;
    }

    if (now.isSame(date, 'day')) {
        return date.format('HH:mm:ss');
    }

    return date.format('DD/MM/YYYY HH:mm:ss');
};

export const IsEmptyGuid = (guid) => {
    return !guid || guid === '00000000-0000-0000-0000-000000000000';
}

export const getColorByGroupKey = (groupKey) => {
    const colors = [
        '#E57373', '#64B5F6', '#81C784', '#FFD54F',
        '#BA68C8', '#4DD0E1', '#A1887F', '#90A4AE'
    ];

    if (!groupKey) return 'transparent';

    // Simple hash from groupKey string
    let hash = 0;
    for (let i = 0; i < groupKey.length; i++) {
        hash = groupKey.charCodeAt(i) + ((hash << 5) - hash);
    }

    const index = Math.abs(hash % colors.length);
    return colors[index];
};
